export enum BudgetFieldsNames {
    RADIO = "filterBudget",
    TOTAL = "budgetTotal",
    CREDIT = "budgetCredit"
}
